export default __webpack_public_path__ + "static/media/resume.44caa180.svg";